import { ErrorProps } from './'
import { NotificationIcon } from './Icon'
import { Box, Text } from '@gassan-ui'
import { cn } from '@lib/cn'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { NotificationLabel } from './Label'

export const Error: FC<ErrorProps> = ({ label }) => {
  const { t } = useTranslation(['user-errors', 'notifications'])
  // If passed a user-error code, e.g. user-error:invalid-voucher-code then use that code to translate it
  const message = label.includes('user-error')
    ? t(label.replace('[GraphQL] ', ''), { ns: 'user-errors' }) ||
      t('refreshAndTryAgain', { ns: 'notifications' })
    : label
  return (
    <div className={cn('flex items-center gap-3', 'sm:grid-cols-[56px,auto] sm:gap-4')}>
      <NotificationIcon className="bg-error/20 text-error" icon="exclamation" />
      <Box>
        <NotificationLabel className="text-error">
          {t('somethingWentWrong', { ns: 'user-errors' })}
        </NotificationLabel>
        <Text as="div" className="mb-0 font-bold text-error">
          {message}
        </Text>
      </Box>
    </div>
  )
}
